import {Component} from '@angular/core';

@Component({
	standalone: false,
	selector: 'im-dialog-section',
	template: `
        <section class="im-dialog-section">
            <ng-content></ng-content>
        </section>
    `,
	styles: [
		`
            .im-dialog-section {
                margin-bottom: 2.5em;
                line-height: 1.5em;
            }
        `
	]
})
/**
 * 대화상자 구역 컴포넌트
 * @todo 사용 확인
 */
export class DialogSectionComponent {
}
